import { toggleHeader } from 'common/store/workspaces/actions';
import { GenericContextMenu } from 'common/components/contextMenu/interfaces';

export function getGenericContextMenu(featureId: string): GenericContextMenu {
    return {
        genericActions: [
            {
                actionName: 'toggleHeader',
                secondaryIcon: 'unhide',
                prop: 'withHeader',
                icon: 'hide',
                onClick: toggleHeader(featureId),
            },
        ],
    };
}
